import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from './installmentDataFragment'

const installmentDetails = gql`
  query InstallmentDetails($installmentId: ID!, $isEngineAdmin: Boolean!, $slug: String!) {
    campground(slug: $slug, isEngineAdmin: $isEngineAdmin) {
      electricFeeConfigLegacy {
        amount
      }
      hasLateFeeConfig
      id
      isCountryUs
      installment(id: $installmentId) {
        ...installmentData
        canRefund
        canSend
        hasPendingRefunds
        maxRefundableCamperFee
        maxRefundableCamperProcessingFee
        maxRefundableGrandTotal
        notes {
          id
          text
          createdAt
        }
        payment {
          state
        }
        payoutCompletedByMonthlyCheck
        refunds {
          id
          createdAt
          state
          total {
            display
          }
        }
        reservation {
          hasBalance
          reservationsWithParent {
            code
            from
            id
            installmentFirst {
              total {
                display
              }
            }
            isGroup
            isParent
            links {
              detailsUrl
              paymentsUrl
            }
            site {
              id
              name
            }
            to
            uuid
          }
          state
          uuid
        }
        totalRemaining {
          display
        }
      }
      lateFeeConfig {
        amount
      }
      stripeTerminalReader {
        key
      }
    }
    isNotProduction
  }

  ${InstallmentDataFragment}`

export default installmentDetails
